export const englishText = {
	'access.requestSentFor': 'has sent an access request for',
	'activity.noTasks': 'You have no tasks',
	'activity.sendWithDropbox': 'has sent you files with External Uploader',
	'activity.yourTasks': 'Your tasks',
	'admin.accountManagement': 'Account Management',
	'admin.aiAgents': 'AI Agents',
	'admin.agentActivity': 'Agent activity',
	'admin.aiControlCenter': 'AI Control Center',
	'admin.bynderResources': 'Bynder Resources',
	'admin.knowledgeBase': 'Knowledge base',
	'admin.submitRequest': 'Submit a request',
	'admin.community': 'Community',
	'admin.advancedSettings': 'Advanced settings',
	'admin.analytics': 'Analytics',
	'admin.governance': 'Governance',
	'admin.brandTemplates': 'Brand templates',
	'admin.bynderSuperadmin': 'Bynder superadmin',
	'admin.cockpit': 'Cockpit',
	'admin.editCurrentAccount': 'Edit current account',
	'admin.groupManagement': 'Group Management',
	'admin.homepage': 'Homepage',
	'admin.homepageV2': 'Homepage',
	'admin.insights': 'Insights',
	'admin.lookAndFeel': 'Look & feel',
	'admin.metapropertiesmanagement': 'Metaproperties management',
	'admin.permissionManagement': 'Permission Management',
	'admin.portalSettings': 'Portal settings',
	'admin.reporting': 'Reporting',
	'admin.smartfilterManagement': 'Smartfilter Management',
	'admin.taxonomy': 'Taxonomy',
	'admin.trash': 'Trash',
	'admin.userManagement': 'User Management',
	'admin.usersRights': 'Users & rights',
	'admin.workflow': 'Workflow',
	'adminExtra.newsManagement': 'News Management',
	'brands.makeNew': 'Create new brand',
	'brandstore.goTo': 'Go to brandstore',
	'brandstore.MyCart': 'My cart',
	'brandstore.orderHistory': 'Order history',
	'cart.goToMy': 'Go to my cart',
	'cart.total': 'Cart total',
	'cart.youHaveNoItems': 'You have no products in your cart',
	'collections.allFor': 'All collections for',
	'confirm.RemoveGroup': 'Remove group',
	convertGuidelines: 'Convert Guidelines to PDF',
	'conversationalAi.toggleSidebar': 'Toggle Conversational A.I. sidebar',
	'download.progress': 'download(s) being prepared',
	'download.requestSent': 'has sent a download request.',
	'downloadtask.progress': 'edits/downloads in progress',
	'duplicate.find': 'Find duplicates',
	generalAnotherSearch: 'Why not try another search?',
	generalAudit: 'Audit',
	generalBack: 'Back',
	generalBrands: 'Brands',
	generalCancel: 'Cancel',
	generalCategories: 'Categories',
	generalChangeHistory: 'Change history',
	generalClear: 'Clear',
	GeneralCopyright: 'Copyright',
	generalDownload: 'Download',
	generalErrorSavingChanges: 'Error saving changes',
	generalLanguage: 'Language',
	generalLogin: 'Login',
	generalLogout: 'Logout',
	generalMore: 'More',
	generalNoResultsFor: 'No results for',
	generalQuickLinks: 'Quick links',
	generalResultsFor: 'Results for',
	generalSearch: 'Search',
	generalSettings: 'Settings',
	generalTags: 'Tags',
	generalTaskDownloadReady: 'is ready',
	generalUploadMedia: 'Upload media',
	generalWatch: 'View',
	includeVat: 'Inc. VAT',
	'news.addNews': 'Add news',
	'menuitem.bynderExpress': 'Bynder Express',
	'menuitem.customLinks': 'Custom links',
	'badge.label.new': 'New',
	noresults: 'There are currently no results',
	'quarantine.quarantine': 'Quarantine',
	'request.requestAccess': 'Register a new account',
	save: 'Save',
	'spotlight.searchSomething': 'Want to search for something?',
	'spotlight.searchSomethingNLS': 'Try "smiling woman sitting on a bench"',
	'spotlight.showMetaPropertyResults': 'All {1} results for {2}',
	'spotlight.text': 'Text',
	'spotlight.textInImage': 'Text-in-Image',
	'spotlight.nlsBannerTitle': 'Use natural language search',
	'spotlight.nlsBannerSubtitle': 'Find images by describing them',
	'spotlight.transcript': 'Transcript',
	'spotlightHelp.operators.and.content':
		'Use AND between your search terms to find results that match all your terms.',
	'spotlightHelp.operators.and.example': 'E.g. boston {and} hotel',
	'spotlightHelp.operators.and.title': 'AND operator',
	'spotlightHelp.operators.combinations.content':
		'All the search operators mentioned above can also be used together.',
	'spotlightHelp.operators.combinations.example': 'E.g. bicycle {andnot} city',
	'spotlightHelp.operators.combinations.title': 'Combinations',
	'spotlightHelp.operators.nav': 'Search Operators',
	'spotlightHelp.operators.not.content':
		'Use NOT before a search term to exclude results that match that term.',
	'spotlightHelp.operators.not.example': 'E.g. {not} forest',
	'spotlightHelp.operators.not.title': 'NOT operator',
	'spotlightHelp.operators.or.content':
		'Use OR between your search terms to find results that match any of your terms.',
	'spotlightHelp.operators.or.example': 'E.g. ocean {or} mountains',
	'spotlightHelp.operators.or.title': 'OR operator',
	'spotlightHelp.operators.quotes.content':
		'Wrap your search in “” to find results that are an exact match.',
	'spotlightHelp.operators.quotes.example': 'E.g. “ocean view”',
	'spotlightHelp.operators.quotes.title': 'Double quotes',
	'spotlightHelp.operators.title': 'Search Operators',
	'spotlightHelp.recentSearches': 'Recent Searches',
	'spotlightHelp.shortcuts.close.key': 'ESC',
	'spotlightHelp.shortcuts.close.title': 'Close search',
	'spotlightHelp.shortcuts.down.key': 'Arrow down',
	'spotlightHelp.shortcuts.down.title': 'Navigate to next result',
	'spotlightHelp.shortcuts.nav': 'Keyboard Shortcuts',
	'spotlightHelp.shortcuts.title': 'Keyboard shortcuts',
	'spotlightHelp.shortcuts.up.key': 'Arrow up',
	'spotlightHelp.shortcuts.up.title': 'Navigate to previous result',
	'spotlightHelp.shortcuts.view.key': 'ENTER',
	'spotlightHelp.shortcuts.view.title': 'View results',
	'spotlightHelp.title': 'Search Help',
	'styleguide.pagesAllFor': 'Styleguide pages for {1}',
	'tags.allTagsFor': 'All tags for',
	'task.progress': 'edit(s) in progress',
	'transfer.history': 'Transfer history',
	'upload.bareUploader': 'Mass Uploader',
	'upload.versionUpdater': 'Mass Version Updater',
	'user-outofoffice.BackupUnavailable':
		'This person is unavailable in the selected time range. Please adjust your dates or select someone else.',
	'user-outofoffice.BackupUser': 'Set as backup user',
	'user-outofoffice.Description.KeepReceivingNotifications':
		"Stay in the loop while you're unavailable",
	'user-outofoffice.EndDate': 'End date',
	'user-outofoffice.IsOutOfOfficeUntil': 'Out of office until {1}',
	'user-outofoffice.KeepReceivingNotifications': 'Keep receiving notifications',
	'user-outofoffice.MainAlreadyBackup':
		'You are set as backup for another user in the selected time range. Please adjust your dates.',
	'user-outofoffice.SearchForAUser': 'Search for a user',
	'user-outofoffice.SetOutOfOfficeClear': 'Clear out of office',
	'user-outofoffice.SetOutOfOfficeClearError':
		'We weren’t able to clear your out of office, please try again later.',
	'user-outofoffice.SetOutOfOfficeClearSuccess':
		'Your out of office has been cleared successfully',
	'user-outofoffice.SetOutOfOfficeSuccess': 'Your out of office has been set successfully',
	'user-outofoffice.SetYourselfAsOutOfOffice': 'Set yourself as out of office',
	'user-outofoffice.StartDate': 'Start date',
	'user-outofoffice.UserHasOverlapingOOO':
		'You are already set as out of office in this time range',
	'user.editProfile': 'Edit profile',
	'user.requests': 'User Access Requests',
	'user.workspace': 'Workspace',
	'waitingroom.waitingroom': 'Waiting room',
	'workflow.AddAsset': 'Add asset',
	'workflow.AddGroup': 'Add group',
	'workflow.AddPreset': 'Add preset',
	'workflow.Campaign': '{Campaign}',
	'workflow.CampaignManagement': 'Campaign Management',
	'workflow.Cancel': 'Cancel',
	'workflow.Close': 'Close',
	'workflow.CreateNew': 'Create new',
	'workflow.DeleteConfirmation': 'Are you sure you want to remove {1}?',
	'workflow.EditGroup': 'Edit group',
	'workflow.FTEManagement': 'FTE Management',
	'workflow.GroupManagement': 'Group Management',
	'workflow.Job': '{Job}',
	'workflow.ManageGroups': 'Manage groups',
	'workflow.MetapropertyManagement': 'Metaproperty Management',
	'workflow.Name': 'Name',
	'workflow.No': 'No',
	'workflow.NoGroup': 'No groups found',
	'workflow.PresetManagement': 'Preset Management',
	'workflow.PresetsCampaign': 'Campaign Presets',
	'workflow.PresetsJob': 'Job Presets',
	'workflow.CampaignPresets': '{Campaign} presets',
	'workflow.JobPresets': '{Job} presets',
	'workflow.Remove': 'Remove',
	'workflow.RoleManagement': 'Role Management',
	'workflow.Save': 'Save',
	'workflow.StageAdd': 'Add stage',
	'workflow.StartAddGroup': 'Start adding your first group',
	'workflow.TaskAdd': 'Add task',
	'workflow.TemplateManagement': 'Template Management',
	'workflow.Users': 'Users',
	'workflow.VariableManagement': 'Variable Management',
	'workflow.YesRemove': 'Yes, remove',
};
